export const fold = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

function lev(a, b) {
  const m = a.length, n = b.length;
  if (!m) return n;
  if (!n) return m;
  let prev = Array.from({ length: n + 1 }, (_, j) => j);
  for (let i = 1; i <= m; i++) {
    const cur = [i];
    for (let j = 1; j <= n; j++) {
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    }
    prev = cur;
  }
  return prev[n];
}

// Lower is better; -1 = no match. Tolerates accents and small typos.
export function matchScore(query, name, group = "") {
  const q = fold(query).trim();
  if (!q) return 0;
  const n = fold(name);
  if (n.startsWith(q)) return 0;
  if (n.includes(q)) return 1;
  const words = n.split(/[^a-z0-9]+/).filter(Boolean);
  const g = fold(group);
  let score = 2;
  for (const t of q.split(/\s+/).filter(Boolean)) {
    const tol = t.length >= 7 ? 2 : t.length >= 4 ? 1 : 0;
    let best = 99;
    for (const w of words) {
      if (w.startsWith(t)) { best = 0; break; }
      const d = Math.min(lev(t, w), lev(t, w.slice(0, t.length)));
      if (d <= tol) best = Math.min(best, d + 1);
    }
    if (best === 99 && g.includes(t)) best = 4;
    if (best === 99) return -1;
    score += best;
  }
  return score;
}

export function searchServices(services, query) {
  return services
    .map((s) => ({ s, score: matchScore(query, s.name, s.group) }))
    .filter((x) => x.score >= 0)
    .sort((a, b) => a.score - b.score || a.s.name.localeCompare(b.s.name, "pt-BR"))
    .map((x) => x.s);
}
